<template lang="pug">
    transition-group(
        appear,
        class="ib-transition-slide",
        :css="false",
        @before-enter="beforeEnter",
        @enter="enter",
        @leave="leave")
        slot
</template>

<script>
    /**
    * A slide-in transition group component for fading in lists of items.
    */
    export default {
        name: 'ib-transition-slide',

        props: {
            /**
            * Controls the rate of appearance.
            */
            delay: {
                default: 200
            }
        },

        data() {
            return {
                index: 0
            }
        },

        methods: {
            beforeEnter(el) {
                el.style.opacity = 0;
            },
            enter(el, done) {
                const delay = this.index * this.delay;
                this.index += 1;
                setTimeout(() => {
                    el.style.opacity = 1;
                    el.classList.add('ib-transition-slide-enter');
                }, delay);
            },
            leave(el, done) {
                const delay = this.index * this.delay;
                setTimeout(() => {
                    el.classList.remove('ib-transition-slide-enter');
                    el.classList.add('ib-transition-slide-leave');
                }, delay);
            }
        }
    }
</script>

<style lang="less">
    .ib-transition-slide-enter {
        -webkit-animation: ib-slide 0.3s ease;
        animation: ib-slide 0.3s ease;
    }

    @-webkit-keyframes ib-slide {
        0% {
            -webkit-transform: translateX(-50px);
            transform: translateX(-50px);
        }
        100% {
            -webkit-transform: translateX(0px);
            transform: translateX(0px);
        }
    }

    @keyframes ib-slide {
        0% {
            transform: translateX(-50px);
        }
        100% {
            transform: translateX(0px);
        }
    }
</style>

<docs>
    ```jsx
        new Vue({
            data() { return {
                numbers: [1]
            }},
            methods: {
                click() {
                    this.numbers.push(this.numbers[this.numbers.length - 1] + 1);
                }
            },
            template: `
                <div>
                    <div v-if="numbers.length > 20">Steven, this button will break if you keep clicking it.</div>
                    <div v-if="numbers.length > 10">Elijah, please.</div>
                    <ib-button @click="click">Click Me</ib-button>
                    <ib-transition-slide>
                        <div v-for="num in numbers" key="num">
                            You are number {{ num }}
                        </div>
                    </ib-transition-slide>
                </div>
            `
        });
    ```
</docs>
